import React, { useContext, useState } from 'react';
import { isEmpty } from 'underscore';

// redux
import { useDispatch } from 'react-redux';
import { editQuizQuestion } from 'redux/actions/quizzes';

import NvSwitch from 'shared/components/inputs/nv-switch';
import { SavingRegistryContext } from 'shared/hooks/use-saving-registry';
import QuestionSetContext, { QuestionContext, SavingIndicator } from '../../lecture_pages/services/question-set-context';
import { config } from '../../../config/config.json';

type RequiredQuestionSwitchPropsType = {
  label?: string;
  labelClassName?: string;
};

const RequiredQuestionSwitch = (props: RequiredQuestionSwitchPropsType) => {
  const { label, labelClassName } = props;

  const { currentQuestion } = useContext(QuestionContext);
  const { registerSaving } = useContext(SavingRegistryContext);
  const {
    savingIndicatorTimeoutRef,
    setSavingStatus,
  } = React.useContext(QuestionSetContext);

  const [isRequired, setIsRequired] = useState(currentQuestion?.isRequired);

  const dispatch = useDispatch();

  const handleRequiredChange = (newValue: boolean) => {
    setIsRequired(newValue);
    const unregister = registerSaving();
    setSavingStatus(SavingIndicator.SAVING_STATUS);
    clearTimeout(savingIndicatorTimeoutRef.current);
    dispatch(editQuizQuestion({
      id: currentQuestion.id,
      patch: { isRequired: newValue },

    })).then((res) => {
      if (isEmpty(res.error)) {
        setSavingStatus(SavingIndicator.SUCCESS_STATUS);
      } else {
        setIsRequired(!newValue); // revert switch state on error
        setSavingStatus(SavingIndicator.ERROR_STATUS);
      }
    }).finally(() => {
      unregister();
      savingIndicatorTimeoutRef.current = setTimeout(() => {
        setSavingStatus(SavingIndicator.HIDDEN_STATUS);
      }, 2000);
    });
  };
  return (
    <div className='d-flex'>
      <NvSwitch
        checked={isRequired}
        className='mr-2 d-flex align-items-center'
        data-qa={config.pendo.activities.survey.toggleRequiredQuestion}
        onChange={handleRequiredChange}
      />
      <p className={`${labelClassName} mb-0`}>
        {label}
      </p>
    </div>
  );
};

export default RequiredQuestionSwitch;
